import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckRankForm from "../../components/checkRank/CheckRankForm";
import RankResults from "../../components/checkRank/RankResults";

import { calculateAverageDailyIncrease } from "../../utils/helper";
import SubscriptionModal from "../SubscriptionModal";
import api from "../../utils/axios";
import { Box, Button, Flex, Heading, Progress, Text, useBreakpointValue, useDisclosure, VStack } from "@chakra-ui/react";
import moment from "moment";
import { motion } from "framer-motion";
import MintInfoModal from "./MintInfoModal";
import { useUser } from "../../context/UserContext";
import { useAccount } from "wagmi";
import { CSVLink } from "react-csv";
import { FaDownload } from "react-icons/fa";
import HmacSHA256 from "crypto-js/hmac-sha256";

const STR_DEFF = process.env.REACT_APP_STR_DEFF || "";

const MotionHeading = motion(Heading);
const twitterLink = 'https://twitter.com/intent/tweet?text='

const isKeyMintAvailiable = process.env.REACT_APP_MINT_AVAILIABLE === 'true';

const CheckRank = () => {
	const [rankData, setRankData] = useState(null);
	const [error, setError] = useState('');
	const [showRank, setShowRank] = useState(false);
	const [recentChecks, setRecentChecks] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showChart, setShowChart] = useState(false); // Состояние для отображения графика
	const [chartData, setChartData] = useState([]); // Состояние для данных графика
	const location = useLocation();
	const navigate = useNavigate();
	const { address: connectedAddress } = useAccount();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isMultiple, setIsMultiple] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const { isOpen: isMintModalOpen, onOpen: onMintModalOpen, onClose: onMintModalClose } = useDisclosure();
	const [progress, setProgress] = useState(0);
	const [totalAddresses, setTotalAddresses] = useState(0);
	const isMobile = useBreakpointValue({ base: true, md: false });
	const { user, loading, refreshUserData } = useUser();
	const isUserHasKey = !loading && user && user.mintedKey;

	// useEffect(() => {

	// }, [user.mintedKey]);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const address = queryParams.get('address');

		if (address) {
			if (shouldShowSubscriptionModal()) {
				setShowModal(true);
				onOpen();
			}
		}

		const savedChecks = JSON.parse(localStorage.getItem('recentChecks')) || [];
		setRecentChecks(savedChecks);
	}, [location.search]);


	useEffect(() => {
		if (rankData && rankData.graphData) {
			// Подготовка данных для графика
			setChartData(rankData.graphData);
			setShowChart(true);
		}
	}, [rankData]);

	const handleSwitchChange = async () => {
		window.gtag('event', 'button_click', {
			event_category: 'Button',
			event_label: 'mark_switcher_click',
		});
		await refreshUserData()
		setIsMultiple(!isMultiple && isUserHasKey);
		if (!isUserHasKey && isKeyMintAvailiable) {
			onMintModalOpen();
		}
	};

	const shouldShowSubscriptionModal = () => {
		const twitterSubscribed = localStorage.getItem('twitterSubscribed') === 'true';
		const telegramSubscribed = localStorage.getItem('telegramSubscribed') === 'true';
		const twitterFounderSubscribed = localStorage.getItem('twitterFounderSubscribed') === 'true';
		const postRetweeted = localStorage.getItem('retweetCompleted') === 'true';
		const discordInvited = localStorage.getItem('discordSubscribed') === 'true';

		const savedChecks = JSON.parse(localStorage.getItem('recentChecks')) || [];
		return savedChecks.length > 3 && !localStorage.getItem('hasCompletedSubscription') && !twitterSubscribed && !telegramSubscribed && !twitterFounderSubscribed && !postRetweeted && !discordInvited;
	};



	const fetchRankData = async (address) => {
		try {
			const lastFetchMarksTime = localStorage.getItem('lastFetchMarksTime');
			const currentTime = new Date().getTime();

			if (!isUserHasKey && lastFetchMarksTime && currentTime - lastFetchMarksTime < 3600000) {
				const remainingTime = 3600000 - (currentTime - lastFetchMarksTime); // Time remaining in milliseconds
				const remainingMinutes = Math.floor((remainingTime / 1000) / 60);
				const remainingSeconds = Math.floor((remainingTime / 1000) % 60);

				setError(`Please wait ${remainingMinutes} minute(s) and ${remainingSeconds} second(s) before checking again or Mint key.`);
				return;
			}

			setError('');

			const formattedDate = moment.utc().add(2, 'minutes').format('DD.MM.YYYY HH:mm');;
			const userSignature = localStorage.getItem('userSignature') || null;
			const data = { address, signature: userSignature, user: connectedAddress };
			const stringifiedData = JSON.stringify({ ...data, formattedDate });

			const hmac = HmacSHA256(stringifiedData, STR_DEFF).toString();

			const response = await api.post('/check-rank', data, {
				headers: {
					"Content-Type": "application/json",
					"X-Signature": hmac,
				},
			});

			const newRankData = response.data;
			setRankData(newRankData);
			setShowRank(true);
			setError('');

			const newCheck = {
				address,
				marks: parseFloat(newRankData.points).toFixed(2),
				rank: newRankData.rank,
				percentage: newRankData.percentage,
				timestamp: newRankData.timestamp
			};

			let updatedChecks = [...recentChecks];
			updatedChecks = updatedChecks.filter(check => check.address !== address);
			updatedChecks.push(newCheck);
			if (!isUserHasKey && updatedChecks.length > 5) {
				updatedChecks = updatedChecks.slice(-5);
			}

			setRecentChecks(updatedChecks);
			localStorage.setItem('recentChecks', JSON.stringify(updatedChecks));
			!isUserHasKey && localStorage.setItem('lastFetchMarksTime', currentTime.toString());
		} catch (error) {
			setError('There is currently high traffic on the site due to many users. Please try again later.');
			setRankData(null);
		}
	};

	const fetchMultipleRankData = async (addresses = []) => {
		if (!addresses.length) {
			setError("No addresses provided.");
			return;
		}

		try {
			const formattedDate = moment.utc().format('DD.MM.YYYY');

			const userSignature = localStorage.getItem("userSignature") || null;
			const chunkSize = 3; // Количество адресов в одном запросе
			const addressChunks = [];

			// Разбиваем массив адресов на подмассивы по chunkSize
			for (let i = 0; i < addresses.length; i += chunkSize) {
				addressChunks.push(addresses.slice(i, i + chunkSize));
			}

			setTotalAddresses(addressChunks.length); // Общее количество запросов
			setProgress(0); // Начало прогресса с 0
			setIsLoading(true); // Флаг для начала загрузки

			let completed = 0; // Сброс завершенных запросов
			let allRankData = []; // Собираем все данные рангов



			// Выполняем запросы по частям (чанк)
			const requests = addressChunks.map(async (chunk) => {
				const data = { addresses: chunk, signature: userSignature, user: connectedAddress };
				const stringifiedData = JSON.stringify({ ...data, formattedDate });

				const hmac = HmacSHA256(stringifiedData, STR_DEFF).toString();


				const response = await api.post("/check-rank-multiple", {
					addresses: chunk,
					signature: userSignature,
					user: connectedAddress,
				}, {
					headers: {
						"Content-Type": "application/json",
						"X-Signature": hmac,
					},
				});

				// Добавляем полученные данные в общий массив
				allRankData = [...allRankData, ...response.data];

				// Увеличиваем количество завершенных чанков
				completed += 1;

				// Рассчитываем и обновляем прогресс в процентах
				const newProgress = Math.round((completed / addressChunks.length) * 100);
				setProgress(newProgress); // Устанавливаем новый прогресс
			});

			// Ожидаем завершения всех запросов
			await Promise.all(requests);

			// Обновляем данные рангов после завершения всех запросов
			setRankData(allRankData);

			const newChecks = allRankData.map((data) => ({
				address: data.address,
				marks: parseFloat(data.points).toFixed(2),
				rank: data.rank,
				percentage: data.percentage,
				timestamp: data.timestamp,
			}));

			let updatedChecks = [...recentChecks, ...newChecks];
			updatedChecks = updatedChecks.filter(
				(check, index, self) =>
					index === self.findIndex((c) => c.address === check.address)
			);

			setRecentChecks(updatedChecks);
			localStorage.setItem("recentChecks", JSON.stringify(updatedChecks));

			setIsLoading(false); // Останавливаем индикацию загрузки
		} catch (error) {
			if (
				error.response &&
				error.response.status === 404 &&
				error.response.data.notFoundAddresses
			) {
				const notFoundAddresses = error.response.data.notFoundAddresses;
				setError(
					`One or more addresses not found: ${notFoundAddresses.join(
						", "
					)}. They might not be indexed yet. Please try again later.`
				);
			} else {
				setError(
					"An error occurred while fetching rank data. Please try again later."
				);
			}
			setRankData(null);
			setIsLoading(false);
		}
	};





	const handleSubmit = async (values, { setSubmitting, setErrors }) => {
		const twitterSubscribed = localStorage.getItem('twitterSubscribed') === 'true';
		const telegramSubscribed = localStorage.getItem('telegramSubscribed') === 'true';
		const twitterFounderSubscribed = localStorage.getItem('twitterFounderSubscribed') === 'true';
		const postRetweeted = localStorage.getItem('retweetCompleted') === 'true';
		const discordInvited = localStorage.getItem('discordSubscribed') === 'true';
		const hasCompletedSubscription = localStorage.getItem('hasCompletedSubscription') === 'true' && twitterSubscribed && telegramSubscribed && twitterFounderSubscribed && postRetweeted && discordInvited;

		if (!hasCompletedSubscription && recentChecks.length >= 3) {
			setShowModal(true);
			onOpen();
			setSubmitting(false);
			return;
		}

		try {
			const addresses = values.addresses ? values.addresses.split('\n').map(addr => addr.trim()) : [values.address];
			if (isMultiple && addresses.length > 1) {
				await fetchMultipleRankData(addresses);
			} else {
				const address = values.address || addresses[0];
				const from = values.from;
				const to = values.to;
				await fetchRankData(address, from, to);
				!isMultiple && navigate(`/check-marks-rank?address=${encodeURIComponent(address)}`);
			}
		} catch (error) {
			setErrors({ address: 'There is currently high traffic on the site due to many users. Please try again later.' });
			setRankData(null);
		} finally {
			setSubmitting(false);
		}
	};

	const handleReset = () => {
		setIsLoading(true);
		setShowRank(false);
		setRankData(null);
		setProgress(0);
		setError('');
		navigate('/check-marks-rank');
		setIsLoading(false);
	};

	const handleClearRecentChecks = () => {
		setRecentChecks([]);
		localStorage.removeItem('recentChecks');
	};

	const handleTwitterSubscribe = () => {
		localStorage.setItem('twitterSubscribed', 'true');
	};

	const handleTelegramSubscribe = () => {
		localStorage.setItem('telegramSubscribed', 'true');
	};

	const handleTwitterFounderSubscribe = () => {
		localStorage.setItem('twitterFounderSubscribed', 'true');
	};

	const handleTwitterPostRetweet = () => {
		localStorage.setItem('retweetCompleted', 'true');
	};

	const handleDiscordInvite = () => {
		localStorage.setItem('discordSubscribed', 'true');
	};


	const handleCloseModal = () => {
		const twitterSubscribed = localStorage.getItem('twitterSubscribed') === 'true';
		const telegramSubscribed = localStorage.getItem('telegramSubscribed') === 'true';
		const twitterFounderSubscribed = localStorage.getItem('twitterFounderSubscribed') === 'true';
		const postRetweeted = localStorage.getItem('retweetCompleted') === 'true';
		const discordInvited = localStorage.getItem('discordSubscribed') === 'true';
		if (twitterSubscribed && telegramSubscribed && twitterFounderSubscribed && postRetweeted && discordInvited) {
			localStorage.setItem('hasCompletedSubscription', 'true');
		}
		setShowModal(false);
		onClose();
	};

	const csvData = (() => {
		// Check if rankData is an array or a single object
		if (Array.isArray(rankData)) {
			// Process array of data
			return rankData.map(data => {
				// Initialize object with main data
				let csvRow = {
					address: data.address,
					marks: parseFloat(data.points).toFixed(2),
					top: Math.ceil(data.percentage),
					rank: data.rank,
					updated: moment(data.timestamp).format('DD MMM YYYY'),
					'Average Marks/day': parseFloat(calculateAverageDailyIncrease(data.graphData)).toFixed(2),
				};

				// Add dates and amounts as separate fields
				if (data.graphData && Array.isArray(data.graphData)) {
					data.graphData.forEach(point => {
						const formattedDate = moment(point.date).format('DD.MM.YYYY'); // Format date as header
						csvRow[formattedDate] = parseFloat(point.points).toFixed(2); // Add amount for that date
					});
				}

				return csvRow;
			});
		} else if (rankData && typeof rankData === 'object') {
			// Handle the single object case
			const data = rankData;
			let csvRow = {
				address: data.address,
				marks: parseFloat(data.points).toFixed(2),
				top: Math.ceil(data.percentage),
				rank: data.rank,
				updated: moment(data.timestamp).format('DD MMM YYYY'),
				'Average Marks/day': parseFloat(calculateAverageDailyIncrease(data.graphData)).toFixed(2),
			};

			// Add dates and amounts as separate fields
			if (data.graphData && Array.isArray(data.graphData)) {
				data.graphData.forEach(point => {
					const formattedDate = moment(point.date).format('DD.MM.YYYY'); // Format date as header
					csvRow[formattedDate] = parseFloat(point.points).toFixed(2); // Add amount for that date
				});
			}

			return [csvRow]; // Return array with single object
		} else {
			// If rankData is neither an array nor a valid object
			return [];
		}
	})();


	return (
		// <Layout>
		<Box padding={4} maxWidth="100%" mx="auto">
			<VStack align="center">
				<Heading
					fontSize="clamp(1.5em, 2.8vw, 2.4em)"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 1 }}
					textAlign={"center"}
					mb={!isMobile ? 1 : 1}
				>
					Check Marks Rank
				</Heading>


				<Box w={isMobile ? '100%' : "700px"}>
					{isLoading && progress !== 100 && (
						<Box pb={2}>
							<Text>Fetching rank data...</Text>
							<Progress hasStripe value={progress} size="md" colorScheme="orange" isAnimated />
							<Text>{Math.round(progress)}% completed</Text>
						</Box>
					)}
					{!showRank && progress !== 100 &&
						<motion.div
							initial={{ opacity: 1 }}
							animate={{ opacity: showRank ? 0 : 1 }}
							transition={{ duration: 0.5 }}
						>
							<CheckRankForm
								isLoading={isLoading}
								isMultiple={isMultiple}
								handleSwitchChange={handleSwitchChange}
								handleSubmit={handleSubmit}
								recentChecks={recentChecks}
								handleClearRecentChecks={handleClearRecentChecks}
								serverError={error}
								isUserHasKey={isUserHasKey}
								isKeyMintAvailiable={isKeyMintAvailiable}
							/>
						</motion.div>
					}
				</Box>

				{(progress === 100 || showRank) &&
					<RankResults
						rankData={rankData}
						handleReset={handleReset}
						csvData={csvData}
						twitterLink={twitterLink}
						chartData={chartData}
						isMobile={isMobile}
						onMintModalOpen={onMintModalOpen}
						isUserHasKey={isUserHasKey}
						isKeyMintAvailiable={isKeyMintAvailiable}
					/>
				}

				{
					(rankData && !isLoading) && (
						<Flex gap={4} justifyContent={"center"} wrap="wrap">
							<Button background="#FF684B" color="white" _hover={{ background: "#FF5733" }} height="48px" onClick={handleReset}>Check Another Address</Button>
							{isUserHasKey &&
								<CSVLink data={csvData} filename="scroll_marks_ranks.csv">
									<Button colorScheme="blue" height="48px" leftIcon={<FaDownload />}>Download CSV</Button>
								</CSVLink>
							}
							{/* <Link isExternal href={twitterLink + twitterText} variant={"outline"} colorScheme="twitter" opacity={0.75} style={{ textDecoration: 'none' }}>
								<Button as="div" variant="outline" height="48px" colorScheme="twitter" leftIcon={<FaTwitter />} size={'md'}>Share on Twitter</Button>
							</Link> */}
						</Flex>
					)
				}

				{
					showModal && (
						<SubscriptionModal
							isOpen={isOpen}
							onClose={handleCloseModal}
							onTwitterSubscribe={handleTwitterSubscribe}
							onTelegramSubscribe={handleTelegramSubscribe}
							onTwitterFounderSubscribe={handleTwitterFounderSubscribe}
							onTwitterPostRetweet={handleTwitterPostRetweet}
							onDiscordInvite={handleDiscordInvite}
						/>
					)
				}

				<MintInfoModal onOpen={onMintModalOpen} onClose={onMintModalClose} isOpen={isMintModalOpen} />
			</VStack>
		</Box>
		// </Layout>
	);
};

export default CheckRank;
